module.exports = __webpack_public_path__ + "img/168.8cbc3643.jpg";